export class User {
    email: string
    num_cliente_sigma: number
    num_depto: number
    organization: string
    user_code: number
    user_id: number
    name: string
    last_name: string

    constructor() {

    }

    fullName() {
        return this.name + ' ' + this.last_name
    }
}